// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBoundary_container__1WzCe","icon":"ErrorBoundary_icon__Fob_7","background":"ErrorBoundary_background__3F1AD"};